module.exports = __webpack_public_path__ + "img/apple.1343261e.svg";